export const toMaterialCategoryList = (raw: unknown): string[] => {
  if (Array.isArray(raw)) return raw as string[];
  if (typeof raw === 'string' && raw) return [raw];
  return [];
};
